

const Dimensions = [
    {
        height                                : 279,
	
        width                                 : 1597,
        

    },


];

export { Dimensions };